var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58333 19C1.58333 19 0 19 0 17.4167C0 15.8333 1.58333 11.0833 9.5 11.0833C17.4167 11.0833 19 15.8333 19 17.4167C19 19 17.4167 19 17.4167 19H1.58333ZM9.5 9.5C10.7598 9.5 11.968 8.99955 12.8588 8.10876C13.7496 7.21796 14.25 6.00978 14.25 4.75C14.25 3.49022 13.7496 2.28204 12.8588 1.39124C11.968 0.500445 10.7598 0 9.5 0C8.24022 0 7.03204 0.500445 6.14124 1.39124C5.25045 2.28204 4.75 3.49022 4.75 4.75C4.75 6.00978 5.25045 7.21796 6.14124 8.10876C7.03204 8.99955 8.24022 9.5 9.5 9.5Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d6379c56bb7f2df024adb00499aeb0ac.svg";
export { ForwardRef as ReactComponent };